export default __webpack_public_path__ + "static/media/KK_R_Right_Top_a-cropped.dcd528b3.svg";